module.exports = __webpack_public_path__ + "static/logo_Mirador-16eb9ec283c98b5de49566b831cb3974.png";